export default function splitSentenceByChar(sentence) {
  let l = sentence?.length;

  if (!l) return ["", ""];

  const words = sentence?.split(" ");
  if (words?.length == 0) return [sentence, ""];
  const half = Math.round((l + 1) / 2);

  let charCount = 0;
  let ind = 0;
  for (let i = 0; i < words.length; i++) {
    const wordLength = words[i].length + 1;
    charCount += wordLength;

    if (charCount > half) {
      ind = i;
      break;
    } else {
    }
  }

  let firstHalf = words.slice(0, ind).join(" ");
  let secondHalf = words.slice(ind).join(" ");

  let firstHalf2 = words.slice(0, ind+1).join(" ");
  let secondHalf2 = words.slice(ind+1).join(" ");
  if (Math.abs(firstHalf.length - secondHalf.length) > Math.abs(firstHalf2.length - secondHalf2.length)) {
    return [firstHalf2, secondHalf2];
  }
  return [firstHalf, secondHalf];
}
